import React from 'react';
import './YellowHint.scss';

const YellowHint = props => {
  return <div className="yellow-hint">{props.children}</div>;
};

export default YellowHint;
